export default __webpack_public_path__ + "static/evolvedoffice-5e3c802087812d4f2bfbee51b70b4fbf.png";